import { $, $$ } from "./dom.js";

export function initFaq() {
  $$(".faq-group__toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const group = btn.closest(".faq-group");
      const willOpen = !group.classList.contains("is-open");
      $$(".faq-group").forEach((g) => {
        g.classList.remove("is-open");
        $(".faq-group__toggle", g)?.setAttribute("aria-expanded", "false");
        g.querySelectorAll(".faq-item").forEach((item) => {
          item.classList.remove("is-open");
          item.querySelector(".faq-item__q")?.setAttribute("aria-expanded", "false");
        });
      });
      if (willOpen) {
        group.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  $$(".faq-item__q").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".faq-item");
      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", String(open));
    });
  });
}
